import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import i18n from '../../utils/i18n'
import { PackagingTypeBodyTemplate } from './PackagingTypeBodyTemplate'

export const PackagingTypeFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const packagingTypes: any[] = [
    'container',
    'containerGlass',
    'containerUnit',
    'fiberMoldPackaging',
    'flexiblePackaging',
    'dimensionallyStablePackaging',
    'gasCartridge',
    'vessels',
    'largeGlassContainer',
    'ibc',
    'fibc',
    'woodenIbc',
    'cardboardIbc',
    'compositeIbc',
    'metalIbc',
    'rigidPlasticIbc',
    'largePackaging',
    'semiRigidPackaging',
    'innerContainer',
    'cartons',
    'lightContainer',
    'measuringContainer',
    'medicalGlass',
    'nestablePackaging',
    'packagingCut',
    'pallet',
    'foamPackaging',
    'rigidPackaging',
    'coatedCarton',
    'volumeStablePackaging',
  ]

  const valueTemplate = (option: any, props: any) => {
    if (option) {
      return PackagingTypeBodyTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => PackagingTypeBodyTemplate(option)

  return (
    <Dropdown
      value={options.value}
      options={packagingTypes}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.search')}
    />
  )
}
